<template>
    <div class="flex-col absolute-center no-result">暂无数据</div>
</template>

<script>
    export default {
        name: "NoResult"
    }
</script>

<style scoped>
    .no-result {
        height: 3rem;
        font-size: .36rem;
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/NoResult.vue